export const REFRESH_ERR_CODE = '412';
